import { Card } from 'antd';

import './StyledCard.scss';

const StyledCard = ({
  children,
  extra,
  title,
  id,
  'data-testid': dataTestId,
}: {
  title?: JSX.Element | string;
  children: JSX.Element;
  extra?: JSX.Element;
  id: string;
  'data-testid'?: string;
}) => {
  return (
    <Card
      id={`${id}_card`}
      data-testid={dataTestId ?? `card-${id}`}
      size="small"
      title={title}
      extra={extra}
      // eslint-disable-next-line sonarjs/deprecation
      bordered={false}>
      {children}
    </Card>
  );
};

export default StyledCard;
